export default {
  attemptKey(contextModule, { key, withShift }) {
    const { getters, commit, rootState, state } = contextModule;

    const { isFreeTextTyping } = state;

    if (rootState.keyboard.enabled) {
      const isCorrect = isFreeTextTyping || getters.expectedKey === key || key.includes('shift');

      commit('setAttemptedKey', {
        character: key,
        withShift,
        isCorrect,
        expected: getters.expectedKey
      });
    }
  },

  setupNewRound({ commit, dispatch }) {
    commit('activity/incrementRound', null, { root: true });
    dispatch('setCurrentStep', { isFirstStep: true });
  },

  setCurrentStep({ commit, rootGetters }, options) {
    commit('activity/incrementStep', options, { root: true });
    function getTypingText() {
      if (rootGetters['activity/currentStep'].answer)
        return rootGetters['activity/currentStep'].answer;
      if (
        rootGetters['activity/currentRound'].typeOverText &&
        rootGetters['activity/currentRound'].typeOverText.description
      )
        return rootGetters['activity/currentRound'].typeOverText.description;
      return '';
    }
    commit('setNewTypingText', getTypingText());
  }
};
